// eslint-disable-next-line import/prefer-default-export
export const DISPLAY_MODAL = 'actionId/DISPLAY_MODAL'
